import Model from './model.js';
import Decimal from 'decimal.js';

export default class LeaveType extends Model {
    urlRoot() { return '/LeaveTypes'; }

    url() {
        if (this.company && !this.get(this.idAttribute)) {
            return `${this.company.url()}/leaveTypes`;
        }
        return super.url();
    }

    constraints() {
        return {
            name: {presence: {message: '^Name is required'}}
        };
    }

    defaults() {
        return {
            accruable: false,
            paid: true,
            carriable: false
        };
    }

    initialize({company = null}) {
        this.idAttribute = 'objectId';
        super.initialize(...arguments);

        this.company = company;
        this.taken = 0;
        this.defaultEntitled = 0;
        this.entitled = 0;
        this.cf = 0;

        return this;
    }

    setTaken(taken = 0) {
        this.taken = taken;
    }

    getTaken() {
        return new Decimal(this.taken)
            .toDP(3, Decimal.ROUND_DOWN)
            .toNumber();
    }

    setDefaultEntitled(defaultEntitled = 0) {
        this.defaultEntitled = defaultEntitled;
    }

    getDefaultEntitled() {
        return new Decimal(this.defaultEntitled)
            .toNumber();
    }

    setEntitled(entitled = 0) {
        this.entitled = entitled;
    }

    getEntitled() {
        return new Decimal(this.entitled)
            .toDP(3, Decimal.ROUND_DOWN)
            .toNumber();
    }

    setCarriedFoward(cf = 0) {
        this.cf = cf;
    }

    getCarriedFoward() {
        return new Decimal(this.cf)
            .toDP(3, Decimal.ROUND_DOWN)
            .toNumber();
    }

    hasDaysEntitled() {
        return this.get('paid');
    }
}



// WEBPACK FOOTER //
// ./app/new-models/leave-type.js